export default "__VITE_ASSET__a5730a69__"